import styled from 'styled-components'
import check from '../../../../assets/certificates/AddParameter/Modal/check.svg'
import cross from '../../../../assets/certificates/AddParameter/Modal/switch-cross.svg'
import vector from '../../../../assets/equipment/vector.svg'
import vectorlight from '../../../../assets/equipment/vectorlight.svg'

export const SubHeaderContainer = styled.div`
  background-color: #fff;
  margin-bottom: 1.5rem;
  padding: 1.3rem 4.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.8rem;
`

export const MainContainer = styled.div`
  background-color: #f4f4f4;
  padding-bottom: 2rem;
  overflow-y: auto;
  max-height: calc(100vh - 200px);
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const SectionName = styled.h2`
  font-size: 1.4rem;
  font-weight: 700;
  width: fit-content;
  margin: 0;
`

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`

export const BreadcrumbsContainer = styled.nav`
  font-size: 14px;
  margin-bottom: 1.5rem;
  
  ol {
    list-style: none;
    padding: 0;
    padding-inline-start: 0;
    margin: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  
  li {
    display: flex;
    align-items: center;
    color: #666;
    
    &:not(:last-child)::after {
      content: '>';
      margin: 0 8px;
      color: #999;
    }
    
    a {
      text-decoration: none;
      color: #0090d3;
      white-space: nowrap;
      cursor: pointer;
      
      &:hover {
        text-decoration: underline;
      }
    }
    
    &:last-child {
      span {
        color: #333;
        white-space: nowrap;
        cursor: default;
      }
    }
  }
`

export const StyledCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

export const CardTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  padding-bottom: 20px;
`

export const StyledCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 25px 20px;
  margin-bottom: 20px;
`

export const FormGrid = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cols}, 1fr);
  gap: 20px 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-size: 14px;
    color: #303030;
    margin-bottom: 8px;
    font-weight: bold;
    min-height: 36px;
    display: block;
  }

  input:not([type='checkbox']),
  select {
    padding: 8px 15px;
    border: 1px solid #ebebeb;
    border-radius: 100px;
    font-size: 14px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    background-color: #ebebeb;
    color: #696969;

    &::placeholder {
      color: #c4c4c4;
    }

    &:disabled {
      background-color: #c4c4c4;
      color: #696969;
      cursor: not-allowed;
      border-color: #c4c4c4;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 30px #ebebeb inset !important;
      -webkit-text-fill-color: #696969 !important;
      box-shadow: 0 0 0 30px #ebebeb inset !important;
      border: 1px solid #ebebeb !important;
    }
  }
  select {
    background-image: url(${vector});
    background-size: 18px 9px;
    background-repeat: no-repeat;
    background-position: right 15px center;
    padding-right: 2.5rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;

    option[value=''] {
      color: #c4c4c4;
    }
    
    option {
      color: #696969;
      background-color: white;
    }

    &:disabled {
      background-image: url(${vectorlight});
      background-size: 32px 16px;
    }
  }
`

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const SearchIcon = styled.span`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  font-size: 16px;
  pointer-events: none;
`

export const ActionButtons = styled.div`
  display: flex;
  gap: 15px;
`

export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`

export const SaveButton = styled.button`
  background-color: #d1d5db;
  color: #9ca3af;
  border: none;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: not-allowed;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;

  &:not(:disabled) {
    background-color: #0090d3;
    color: white;
    cursor: pointer;
  }

  img {
    width: 16px;
    height: 16px;
  }
`

export const AddButton = styled.button`
  background-color: transparent;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    width: 12px;
    height: 12px;
  }
`

export const GradeRow = styled.div`
  margin-bottom: 20px;
  padding-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
`

export const GradeHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
`

export const GradeLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`

export const GradeOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 63px;
`

export const SizeButton = styled.button`
  padding: 10px 18px;
  background-color: #f3f4f6;
  color: #6b7280;
  border: 1px solid #e5e7eb;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  min-width: 55px;
  height: 38px;

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &.selected {
    background-color: #e0f2fe;
    color: #0090d3;
    border-color: #0090d3;
    font-weight: 600;
  }
`

export const ToggleSwitchContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 34px;
  cursor: pointer;
`

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .slider {
    background-color: #0090d3;
    border-color: #0090d3;
  }

  &:checked + .slider:before {
    background-image: url(${check});
    background-color: #fff;
    transform: translateX(13px);
  }
`

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
  border: 2px solid #696969;

  &:before {
    display: block;
    position: relative;
    content: '';
    height: 24px;
    width: 24px;
    left: 4px;
    top: 2.8px;
    background-color: #696969;
    border-radius: 50%;
    transition: all 0.4s;
    background-image: url(${cross});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 11px;
  }
`

export const GroupRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 20px;
  margin-bottom: 15px;
  align-items: end;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 4px;

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    align-self: flex-start;
  }
`

export const AddButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding-top: 10px;
`

export const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const DropdownHeader = styled.div`
  padding: 8px 15px;
  border-radius: 100px;
  font-size: 14px;
  background-color: #ebebeb;
  color: #696969;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
  box-sizing: border-box;
  height: 40px;
  line-height: 22px;
  overflow: hidden;
  position: relative;
  background-image: url(${vector});
  background-size: 18px 9px;
  background-repeat: no-repeat;
  background-position: right 15px center;
  padding-right: 2.5rem;

  span {
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 10px;
    color: #696969;
  }
`

export const DropdownIcon = styled.span<{ isOpen: boolean }>`
  display: none;
`

export const DropdownMenu = styled.ul`
  position: absolute;
  top: calc(100% + 4px); 
  left: 0;
  right: 0;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background-color: white;
  list-style: none;
  padding: 8px 0;
  margin: 0;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 250px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c0c0c0;
    border-radius: 4px;
  }
`

export const DropdownItem = styled.li`
  padding: 10px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  display: flex;
  align-items: center;
  gap: 12px;

  span {
    flex: 1;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  cursor: pointer;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  background-color: white;
  display: grid;
  place-content: center;
  margin: 0;

  &:checked {
    background-color: #0090d3;
    border-color: #0090d3;
  }

  &:checked::before {
    content: "";
    width: 10px;
    height: 10px;
    box-shadow: inset 1em 1em white;
    transform-origin: center;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  }
`

export const FamilyTagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`

export const FamilyTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 100px;
  font-size: 14px;
  color: #303030;
  font-weight: 500;
`

export const RemoveTagButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 10px;
    height: 10px;
  }
`

export const TecidosTableWrapper = styled.div`
  overflow-x: auto;
  margin-bottom: 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  position: relative;

  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #d1d5db;
    border-radius: 4px;
  }
`

export const TecidosTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: white;
`

export const TecidosTableHead = styled.thead`
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
`

export const TecidosTableHeader = styled.th<{ $isSticky?: boolean; $left?: string }>`
  padding: 11px 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  white-space: nowrap;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;

  ${props => props.$isSticky && `
    position: sticky;
    left: ${props.$left || '0'};
    z-index: 10;
    background-color: #f9fafb;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
  `}

  &:first-child {
    border-top-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    text-align: center;
    width: 80px;
    position: sticky;
    right: 0;
    z-index: 10;
    background-color: #f9fafb;
    box-shadow: -2px 0 4px rgba(0, 0, 0, 0.08);
  }
`

export const TecidosTableBody = styled.tbody``

export const TecidosTableRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }
`

export const TecidosTableCell = styled.td<{ 
  rowSpan?: number; 
  withBorder?: boolean;
  $isSticky?: boolean;
  $left?: string;
}>`
  padding: 10px 12px;
  vertical-align: middle;
  font-size: 13px;
  color: #374151;
  background-color: white;
  
  ${props => props.withBorder && `
    border-right: 1px solid #e5e7eb;
  `}

  ${props => props.rowSpan && `
    vertical-align: top;
  `}

  ${props => props.$isSticky && `
    position: sticky;
    left: ${props.$left || '0'};
    z-index: 5;
    background-color: white;
    box-shadow: 2px 0 4px rgba(0, 0, 0, 0.08);
  `}
`

export const TableSelect = styled.select`
  width: 100%;
  min-width: 130px;
  padding: 6px 30px 6px 10px;
  border: 1px solid #ebebeb;
  border-radius: 100px;
  font-size: 13px;
  background-color: #ebebeb;
  background-image: url(${vector});
  background-size: 16px 8px;
  background-repeat: no-repeat;
  background-position: right 10px center;
  cursor: pointer;
  outline: none;
  color: #696969;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &::placeholder {
    color: #c4c4c4;
  }

  &:disabled {
    background-color: #c4c4c4;
    color: #696969;
    cursor: not-allowed;
    border-color: #c4c4c4;
  }

  option {
    color: #696969;
    background-color: white;
  }

  option[value=''] {
    color: #c4c4c4;
  }
`

export const TableInput = styled.input`
  width: 100%;
  min-width: 120px;
  padding: 8px 12px;
  border: 1px solid #ebebeb;
  border-radius: 100px;
  font-size: 14px;
  background-color: #ebebeb;
  outline: none;
  color: #696969;

  &::placeholder {
    color: #c4c4c4;
  }

  &:disabled {
    background-color: #c4c4c4;
    color: #696969;
    cursor: not-allowed;
    border-color: #c4c4c4;
  }
`

export const TableActionCell = styled.td`
  padding: 10px 12px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
  position: sticky;
  right: 0;
  z-index: 5;
  box-shadow: -2px 0 4px rgba(0, 0, 0, 0.08);
`

export const TableActionsGroup = styled.div`
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;
`

export const SmallAddButton = styled.button`
  background-color: transparent;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 5px 8px;
  border-radius: 16px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 3px;

  img {
    width: 12px;
    height: 12px;
  }
`

export const TableSelectCor = styled.select`
  width: 100%;
  min-width: 110px;
  padding: 6px 30px 6px 10px;
  border: 1px solid #ebebeb;
  border-radius: 100px;
  font-size: 13px;
  background-color: #ebebeb;
  background-image: url(${vector});
  background-size: 16px 8px;
  background-repeat: no-repeat;
  background-position: right 10px center;
  cursor: pointer;
  outline: none;
  color: #696969;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &::placeholder {
    color: #c4c4c4;
  }

  &:disabled {
    background-color: #c4c4c4;
    color: #696969;
    cursor: not-allowed;
    border-color: #c4c4c4;
  }

  option {
    color: #696969;
    background-color: white;
  }

  option[value=''] {
    color: #c4c4c4;
  }
`